export { Assignments as AssignmentsTable } from './Assignments';
